import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ListEditorDefaultList(_ref) {
  let {
    data,
    onEditSelect,
    onDeleteSelect
  } = _ref;
  return /*#__PURE__*/_jsx("ul", {
    children: data && data.map && data.map((v, i) => /*#__PURE__*/_jsxs("li", {
      children: [/*#__PURE__*/_jsx("span", {
        onClick: () => {
          onEditSelect(i);
        },
        children: /*#__PURE__*/_jsx("code", {
          children: JSON.stringify(v)
        })
      }), /*#__PURE__*/_jsxs("span", {
        onClick: () => {
          onDeleteSelect(i);
        },
        children: [' ', "X"]
      })]
    }, i))
  });
}